type Args = {
  cartId: string;
  page: 'get' | 'embed' | 'receive';
  showFeedbackIfApplicable?: () => void;
  /** Must come from useSetAtom in the React tree (Provider store). */
  setShowLoading: (show: boolean) => void;
};

/**
 * Ask the server to create an Instacart IDP shopping-list link, then open it.
 * The Instacart API key and IDP call stay on the server (/api/instacart).
 * Shows a loading modal while the request is in flight.
 */
export const sendCartToInstacart = ({
  cartId,
  page,
  showFeedbackIfApplicable,
  setShowLoading,
}: Args) => {
  setShowLoading(true);

  fetch(`/api/instacart?cart=${encodeURIComponent(cartId)}`, { credentials: 'include' })
    .then(async (res) => {
      if (!res.ok) {
        throw new Error(`instacart api status ${res.status}`);
      }
      return res.json() as Promise<{ url?: string; error?: string }>;
    })
    .then((data) => {
      if (!data?.url) {
        throw new Error(data?.error || 'missing instacart url');
      }

      if (page === 'get' || page === 'receive') {
        window.location.href = data.url;
      } else {
        window.open(data.url, '_blank');
        setShowLoading(false);
      }

      showFeedbackIfApplicable?.();
    })
    .catch((err) => {
      console.error('sendCartToInstacart failed', err);
      setShowLoading(false);
    });

  return;
};
